import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useParams, Link } from 'react-router-dom'

import {
  selectPropertyManagers,
  fetchPropertyManagers,
} from '../../../reducers/Organisation/propertyManagersReducer'
import Avatar from '../../../Avatar'
import { getAssetLink } from '../../../helpers/get-asset-link'
import CollectionItem from '../../Collection/CollectionItem'
import CollectionList from '../../Collection/CollectionList'

const PropertyManagersList = () => {
  const dispatch = useDispatch()
  const managers = useSelector(selectPropertyManagers)
  const { propertyManagerId } = useParams()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      await dispatch(fetchPropertyManagers())
      setIsLoading(false)
    }
    fetchData()
  }, [dispatch])

  return (
    <>
      {isLoading ? (
        <div className="is-loading" style={{ marginTop: '50%' }} />
      ) : (
        <CollectionList>
          {managers?.map((manager) => (
            <Link
              key={manager.id}
              to={`/dashboard/organisation/property-managers/legacy/${manager.id}`}
            >
              <CollectionItem rounded mark isHighlight={Number(propertyManagerId) === manager.id}>
                <Avatar size="big">
                  <img
                    src={getAssetLink({ path: 'chitown-avatar/avatar', file: manager.user.avatar })}
                    alt=""
                  />
                </Avatar>
                <strong>
                  {manager.user.firstName} {manager.user.lastName}
                </strong>
                <span>{manager.user.email}</span>
              </CollectionItem>
            </Link>
          ))}
        </CollectionList>
      )}
    </>
  )
}

export default PropertyManagersList
